import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client.ts';
import { useSession } from '../../state/session.tsx';
import { companyHasPlanFeature } from '../plan-gate.tsx';

/**
 * Whether this person may open job chat settings, and whether that is still
 * being worked out.
 *
 * Job chat settings are read and saved by owners and managers only, on a plan
 * carrying `job_chat`, and only where this deployment has job chat switched
 * on for the company — which only the capability route knows. The card asks
 * the same question before it renders, so its nav entry and its page have to
 * as well. The settings route also needs schedule:read, which a manager
 * without an active location assignment does not have (the session's
 * permissions are location-scoped, as the server's are).
 */
export function useJobChatSettingsAccess(): { loading: boolean; available: boolean } {
  const { company, user, can } = useSession();
  const role = (user?.role === 'owner' || user?.role === 'manager') && can('schedule:read');
  const planned = company !== null && companyHasPlanFeature(company, 'job_chat');
  const capability = useQuery({
    queryKey: ['job-chat-capability'],
    queryFn: () => api.getFresh<{ enabled: boolean; plan: string }>('/job-chats/capability'),
    enabled: role && planned,
  });
  return {
    loading: capability.isLoading,
    available: role && planned && capability.data?.enabled === true && capability.data.plan !== 'free',
  };
}
